const API_URL = process.env.REACT_APP_API_URL;
const TOKEN_KEY = "techsprout_token";
const USER_KEY = "techsprout_user";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredUser() {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function setSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function isLoggedIn() {
  return Boolean(getToken());
}

async function request(path, { method = "GET", body, auth = true } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const token = getToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (response.status === 401 && auth) {
    clearSession();
    window.location.href = "/login";
    throw new Error("Session expired");
  }

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Request failed with status ${response.status}`);
  }
  return data;
}

export async function login(username, password) {
  const data = await request("/login", { method: "POST", body: { username, password }, auth: false });
  setSession(data.token, { username: data.username, name: data.name, role: data.role });
  return data;
}

// Reading lesson content is public (2026-09-20) - these never send a token.
export function getTodayLesson() {
  return request("/lesson/today", { auth: false });
}

export function getLessons({ page = 1, pageSize = 20, topic, date } = {}) {
  const params = new URLSearchParams({ page, page_size: pageSize });
  if (topic) params.set("topic", topic);
  if (date) params.set("date", date);
  return request(`/lessons?${params.toString()}`, { auth: false });
}

export function getSearchIndex() {
  return request("/search-index", { auth: false });
}

export function getStats() {
  return request("/stats", { auth: false });
}

export function addUser({ username, name, password }) {
  return request("/users", { method: "POST", body: { username, name, password } });
}

export function patchUser(username, updates) {
  return request(`/users/${encodeURIComponent(username)}`, { method: "PATCH", body: updates });
}

export function deleteUser(username) {
  return request(`/users/${encodeURIComponent(username)}`, { method: "DELETE" });
}
